import Store from 'redux/Store'

const getPageSize = (): number => {
  return Store.getState().settings.pageSize
}

export default getPageSize
